import * as React from "react";
import {
  List, Datagrid, TextField, NumberField, UrlField,
  Show, SimpleShowLayout, TextInput, SelectInput,
} from "react-admin";
import { JsonField } from "../../components/JsonField";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField, TechInfo } from "../../components/ui";

// Lecture seule : les écritures sont réservées au créateur du produit côté
// backend (403 pour l'admin). Champs = ProductDTO. Filtres GET /products
// supportés : category (enum ProductCategory), createdByUserId.
const CATEGORY_CHOICES = [
  { id: "NUTRITION", name: "Nutrition" },
  { id: "MATERIEL", name: "Matériel" },
  { id: "TEXTILE", name: "Textile" },
  { id: "SOIN", name: "Soin" },
  { id: "TECH", name: "Tech" },
];

const filters = [
  <SelectInput key="category" source="category" label="Catégorie" choices={CATEGORY_CHOICES} alwaysOn />,
  <TextInput key="createdByUserId" source="createdByUserId" label="ID créateur" />,
];

export default {
  list: () => (
    <List filters={filters}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="brand" />
        <TextField source="category" />
        <TextField source="price" label="Prix" />
        <NumberField locales="fr-FR" source="rating" label="Note" />
        <NumberField locales="fr-FR" source="reviews" label="Avis" />
        <FrDateField source="createdAt" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="summary" label="Résumé" />
        <TextField source="brand" />
        <TextField source="category" />
        <TextField source="price" label="Prix" />
        <NumberField locales="fr-FR" source="score" />
        <NumberField locales="fr-FR" source="rating" label="Note" />
        <NumberField locales="fr-FR" source="reviews" label="Avis" />
        <NumberField locales="fr-FR" source="proCount" label="Pros recommandant" />
        <TextField source="validatedBy" label="Validé par" />
        <UrlField source="productUrl" label="Lien produit" target="_blank" rel="noopener noreferrer" />
        <UserRefField source="createdByUserId" label="Créé par" />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};
